import { useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useInitialLocale } from '~/components/useInitialLocale'

import api from '../api'

function selectState(state) {
  return {
    products: state.app.searchProductResults || state.app.products,
    currentProduct: state.app.currentProduct,
  }
}

function ProductDetailsPage({ config, match, position, location, openDrawerProduct, closeDrawerProduct }) {
  const { products, currentProduct } = useSelector(selectState)
  const localeRefValue = useInitialLocale(location.search)

  const fetchProductAndShow = useCallback(
    async (gtin) => {
      const searchParams = position.getParams()
      let product

      if (products) {
        product = products.find((i) => i.gtin === gtin)
      }

      if (!product) {
        product = (await api.search({ ...searchParams, gtin, locale: localeRefValue.current }))[0]
      }

      openDrawerProduct({
        product,
        buyOnline: config.buyOnline,
        fixedLink: config.fixedLink,
        disableFind: !!currentProduct,
      })
    },
    [products, currentProduct, position.fetched],
  )

  useEffect(() => {
    fetchProductAndShow(match.params.gtin)

    return closeDrawerProduct
  }, [location.key, position.fetched])

  return null
}

export default ProductDetailsPage
